import { useNavigate } from "react-router-dom";
import { FaSearch } from "react-icons/fa";

export default function AllPendingInvoicesTable() {
    const navigate = useNavigate();

    const handleNavigate = (invoiceno) => {
        navigate(`/${invoiceno}`);
    };

    const data = [
        { id: 1, invoiceno: "1111", invoicedate: "Wed 20 May 2022 ", status: "Sucess", amount: "$2000" },
        { id: 2, invoiceno: "2222", invoicedate: "Fri 22 May 2022 ", status: "Sucess", amount: "$2000" },
    ];

    return (
        <div className="customer-container my-4">
            <div className="special-header panel-white-all">
                <h4 className="page-title mt-1">Customer All Invoices</h4>
            </div>

            <div className="table-top-filters d-flex flex-wrap gap-3">

                {/* Invoice No */}
                <div style={{ position: "relative", maxWidth: "200px" }}>
                    <FaSearch
                        style={{
                            marginTop: '-4px',
                            marginLeft: '-10px',
                            position: "absolute",
                            top: "50%",
                            left: "10px",
                            transform: "translateY(-50%)",
                            fontSize: "13px",
                            color: "#999"
                        }}
                    />
                    <input
                        type="text"
                        className="form-control form-control-sm"
                        placeholder="Invoice No"
                        style={{ paddingLeft: "30px" }}
                    />
                </div>

                {/* Status */}
                <div style={{ position: "relative", maxWidth: "200px" }}>
                    <FaSearch
                        style={{
                            marginTop: '-4px',
                            marginLeft: '-10px',
                            position: "absolute",
                            top: "50%",
                            left: "10px",
                            transform: "translateY(-50%)",
                            fontSize: "13px",
                            color: "#999"
                        }}
                    />
                    <input
                        type="text"
                        className="form-control form-control-sm"
                        placeholder="Status"
                        style={{ paddingLeft: "30px" }}
                    />
                </div>

                <button type="button" className="btn custom-btn" style={{ height: '40px', width: '80px' , marginTop: '-4px' }}>
                    Clear
                </button>
            </div>

            <div className="card">
                <div className="card-body p-0">
                    <div className="table-responsive">
                        <table className="custom-table" style={{ marginTop: '-8px' }}>
                            <thead>
                                <tr>
                                    <th style={{ textAlign: 'center' }}>Sr No</th>
                                    <th style={{ textAlign: 'center' }}>Invoice No</th>
                                    <th style={{ textAlign: 'center' }}>Invoice Date</th>
                                    <th style={{ textAlign: 'center' }}>Amount</th>
                                    <th style={{ textAlign: 'center' }}>Status</th>
                                    <th style={{ textAlign: 'center' }}>Action</th>
                                </tr>
                            </thead>

                            <tbody>
                                {data.map((row) => (
                                    <tr key={row.id}>
                                        <td style={{ textAlign: 'center' , fontSize: '13px' }}>{row.id}</td>
                                        <td style={{ textAlign: 'center' , fontSize: '13px' }}>{row.invoiceno}</td>
                                        <td style={{ textAlign: 'center' , fontSize: '13px' }}>{row.invoicedate}</td>
                                        <td style={{ textAlign: 'center' , fontSize: '13px' }}>{row.amount}</td>
                                        <td style={{ textAlign: 'center' , fontSize: '13px' }}>{row.status}</td>
                                        <td style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' , fontSize: '13px' }}>
                                            <button
                                                type="button"
                                                className="btn"
                                                onClick={() => handleNavigate(row.invoiceno)}
                                                title="View"
                                            >
                                                <i className="bi bi-eye"></i>
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>

                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
}
